import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue";
const _hoisted_1 = { class: "v2-modal__content p-large d-flex flex-column align-items-center" };
const _hoisted_2 = {
    class: "d-flex flex-column align-items-center text-center",
    style: { "max-width": "220px" }
};
const _hoisted_3 = { class: "v2-title--large-2" };
const _hoisted_4 = { class: "v2-text--small text-v2-secondary mt-mini-2" };
const _hoisted_5 = { class: "d-flex flex-column d-gap-12 w-100" };
import { computed, onMounted } from 'vue';
import FeatureLocked from '@/components/illustrations/feature-locked.vue';
import { useSubscriptionStore } from '@/stores/subscription';
import { openCrispChat } from '@/utils/crisp';
import { trackFeatureGateHit } from '@/utils/tracking/feature-gate-tracker';
export default /*@__PURE__*/ _defineComponent({
    __name: 'plan-limited-modal',
    props: {
        modelValue: { type: Boolean },
        feature: { default: 'general' }
    },
    emits: ['update:modelValue'],
    setup(__props, { emit: __emit }) {
        const emit = __emit;
        const props = __props;
        onMounted(() => {
            trackFeatureGateHit(props.feature);
        });
        const modelValue = computed({
            get: () => props.modelValue,
            set: (value) => emit('update:modelValue', value),
        });
        function viewPlans() {
            useSubscriptionStore().setShowComparison(true);
            modelValue.value = false;
        }
        function contactUs() {
            openCrispChat();
            modelValue.value = false;
        }
        return (_ctx, _cache) => {
            const _component_s_button_v2 = _resolveComponent("s-button-v2");
            const _component_s_modal = _resolveComponent("s-modal");
            return (_openBlock(), _createBlock(_component_s_modal, {
                size: "sm",
                "modal-class": ['v2-modal ledger-font'],
                modelValue: modelValue.value,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((modelValue).value = $event))
            }, {
                default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_1, [
                        _createElementVNode("div", _hoisted_2, [
                            _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.$t('subscription.limited_plan_modal.title')), 1),
                            _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.$t('subscription.limited_plan_modal.description')), 1),
                            _createVNode(FeatureLocked, { class: "mt-big mb-large" })
                        ]),
                        _createElementVNode("div", _hoisted_5, [
                            _createVNode(_component_s_button_v2, {
                                onClick: viewPlans,
                                theme: "primary",
                                class: "w-100"
                            }, {
                                default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_ctx.$t('subscription.limited_plan_modal.view_plans')), 1)
                                ]),
                                _: 1
                            }),
                            _createVNode(_component_s_button_v2, {
                                onClick: contactUs,
                                theme: "ghost-accent",
                                class: "w-100"
                            }, {
                                default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_ctx.$t('subscription.limited_plan_modal.contact_us')), 1)
                                ]),
                                _: 1
                            })
                        ])
                    ])
                ]),
                _: 1
            }, 8, ["modelValue"]));
        };
    }
});
